"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _GridContainer = _interopRequireDefault(require("../../components/Grid/GridContainer/GridContainer"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _excluded = ["mainHeading", "values"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledLayoutContainer = (0, _styledComponents.default)(_GridContainer.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 75px; \n  padding-top: 75px;\n  padding-left: 10px !important; \n  padding-right: 10px !important;\n  overflow: hidden;\n"])));
var StyledGridItem = (0, _styledComponents.default)(_Grid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  padding: 10px\n"])));
var StyledHeading = (0, _styledComponents.default)(_Heading.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 15px;\n"])));
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    white: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var OurValues = function OurValues(_ref3) {
  var mainHeading = _ref3.mainHeading,
    values = _ref3.values,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledLayoutContainer, Object.assign({
    justifyContent: "flex-start"
  }, props), _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), mainHeading), _react.default.createElement(_TwoColumnLayout.default, null, values.map(function (value) {
    return _react.default.createElement(StyledGridItem, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6
    }, _react.default.createElement(StyledHeading, {
      h4: true,
      teal: true
    }, " ", value.heading, " "), _react.default.createElement(_Heading.default, {
      hsub: true,
      black: true
    }, " ", value.subheading, " "), _react.default.createElement(_Paragraph.default, {
      grey: true
    }, " ", value.paragraph, " "));
  }))));
};
var _default = OurValues;
exports.default = _default;